const alarmsChartVariablesData = [
    {
        value: 'Group_1',
        label: 'Group 1',
        variables: [
            {
                value: 'dccu_alr::icat_current_operation_range_failure[b1]',
                label: 'dccu_alr::icat_current_operation_range_failure[b1]',
            },
            {
                value: 'dccu_alr::idiff_current_operation_range_failure[b1]',
                label: 'dccu_alr::idiff_current_operation_range_failure[b1]',
            },
            {
                value: 'dccu_alr::iret_current_operation_range_failure[b1]',
                label: 'dccu_alr::iret_current_operation_range_failure[b1]',
            },
            {
                value: 'dccu_alr::vbus_voltage_max_operation_range_failure[b1]',
                label: 'dccu_alr::vbus_voltage_max_operation_range_failure[b1]',
            },
            {
                value: 'dccu_alr::vcat_voltage_max_operation_range_failure[b1]',
                label: 'dccu_alr::vcat_voltage_max_operation_range_failure[b1]',
            },
        ],
    },
    {
        value: 'Group_2',
        label: 'Group 2',
        variables: [
            { value: 'dsp1::l2_ci_bfs_i_ess_ref_0[r32]', label: 'dsp1::l2_ci_bfs_i_ess_ref_0[r32]' },
            { value: 'dsp1::l2_ci_bfs_i_ess_ref_1[r32]', label: 'dsp1::l2_ci_bfs_i_ess_ref_1[r32]' },
            { value: 'dsp1::l2_ci_i_l_ref_0[r32]', label: 'dsp1::l2_ci_i_l_ref_0[r32]' },
            { value: 'dsp1::l2_ci_i_l_ref_1[r32]', label: 'dsp1::l2_ci_i_l_ref_1[r32]' },
            { value: 'dsp1::l2_ci_sp_i_ess_ref_0[r32]', label: 'dsp1::l2_ci_sp_i_ess_ref_0[r32]' },
            { value: 'dsp1::l2_ci_sp_i_ess_ref_1[r32]', label: 'dsp1::l2_ci_sp_i_ess_ref_1[r32]' },
            { value: 'dsp1::l2_ci_v_ref_0[r32]', label: 'dsp1::l2_ci_v_ref_0[r32]' },
            { value: 'dsp1::l2_ci_v_ref_1[r32]', label: 'dsp1::l2_ci_v_ref_1[r32]' },
            { value: 'dsp1::l2_cp_sp_i_ess_ref_0[r32]', label: 'dsp1::l2_cp_sp_i_ess_ref_0[r32]' },
            { value: 'dsp1::l2_cp_sp_i_ess_ref_1[r32]', label: 'dsp1::l2_cp_sp_i_ess_ref_1[r32]' },
            { value: 'dsp1::l2_cv2ci_i_ess_ref_0[r32]', label: 'dsp1::l2_cv2ci_i_ess_ref_0[r32]' },
            { value: 'dsp1::l2_cv2ci_i_ess_ref_1[r32]', label: 'dsp1::l2_cv2ci_i_ess_ref_1[r32]' },
            { value: 'dsp1::l2_i_busref_0[r32]', label: 'dsp1::l2_i_busref_0[r32]' },
            { value: 'dsp1::l2_i_busref_1[r32]', label: 'dsp1::l2_i_busref_1[r32]' },
        ],
    },
    {
        value: 'Group_3',
        label: 'Group 3',
        variables: [
            { value: 'dsp1::l2_v_busref_0[r32]', label: 'dsp1::l2_v_busref_0[r32]' },
            { value: 'dsp1::l2_v_busref_1[r32]', label: 'dsp1::l2_v_busref_1[r32]' },
            { value: 'dsp1::sat_i_bus_max_0[r32]', label: 'dsp1::sat_i_bus_max_0[r32]' },
            { value: 'dsp1::sat_i_bus_max_1[r32]', label: 'dsp1::sat_i_bus_max_1[r32]' },
            { value: 'dsp1::sat_i_bus_min_0[r32]', label: 'dsp1::sat_i_bus_min_0[r32]' },
            { value: 'dsp1::sat_i_bus_min_1[r32]', label: 'dsp1::sat_i_bus_min_1[r32]' },
            { value: 'dsp1::sat_i_dcdc_max_0[r32]', label: 'dsp1::sat_i_dcdc_max_0[r32]' },
            { value: 'dsp1::sat_i_dcdc_max_1[r32]', label: 'dsp1::sat_i_dcdc_max_1[r32]' },
            { value: 'dsp1::sat_i_ecss_low_max_0[r32]', label: 'dsp1::sat_i_ecss_low_max_0[r32]' },
            { value: 'dsp1::sat_i_ecss_low_max_1[r32]', label: 'dsp1::sat_i_ecss_low_max_1[r32]' },
            { value: 'dsp1::sat_i_ecss_low_min_0[r32]', label: 'dsp1::sat_i_ecss_low_min_0[r32]' },
            { value: 'dsp1::sat_i_ecss_low_min_1[r32]', label: 'dsp1::sat_i_ecss_low_min_1[r32]' },
            { value: 'dsp1::cst_state_0[u32]', label: 'dsp1::cst_state_0[u32]' },
            { value: 'dsp1::cst_state_1[u32]', label: 'dsp1::cst_state_1[u32]' },
        ],
    },
    {
        value: 'Group_4',
        label: 'Group 4',
        variables: [
            { value: 'dsp1::dcdc_ref_a[r32]', label: 'dsp1::dcdc_ref_a[r32]' },
            { value: 'dsp1::dcdc_ref_b[r32]', label: 'dsp1::dcdc_ref_b[r32]' },
            { value: 'dsp1::dcdc_ref_c[r32]', label: 'dsp1::dcdc_ref_c[r32]' },
            { value: 'dsp1::dcdc_ref_d[r32]', label: 'dsp1::dcdc_ref_d[r32]' },
            { value: 'dsp1::ecss_act_pow_1[r32]', label: 'dsp1::ecss_act_pow_1[r32]' },
            { value: 'dsp1::ecss_act_pow_2[r32]', label: 'dsp1::ecss_act_pow_2[r32]' },
            { value: 'dsp1::ft_analog_1[u32]', label: 'dsp1::ft_analog_1[u32]' },
            { value: 'dsp1::ft_analog_2[u32]', label: 'dsp1::ft_analog_2[u32]' },
            { value: 'dsp1::ft_analog_frw[u32]', label: 'dsp1::ft_analog_frw[u32]' },
            { value: 'dsp1::ft_digital[u32]', label: 'dsp1::ft_digital[u32]' },
            { value: 'dsp1::i_a[r32]', label: 'dsp1::i_a[r32]' },
            { value: 'dsp1::i_b[r32]', label: 'dsp1::i_b[r32]' },
            { value: 'dsp1::i_c[r32]', label: 'dsp1::i_c[r32]' },
            { value: 'dsp1::i_cat[r32]', label: 'dsp1::i_cat[r32]' },
            { value: 'dsp1::i_d[r32]', label: 'dsp1::i_d[r32]' },
            { value: 'dsp1::i_ecss_max_c_0[r32]', label: 'dsp1::i_ecss_max_c_0[r32]' },
            { value: 'dsp1::i_ecss_max_c_1[r32]', label: 'dsp1::i_ecss_max_c_1[r32]' },
        ],
    },
    {
        value: 'Group_5',
        label: 'Group 5',
        variables: [
            { value: 'dsp1::i_ecss_max_d_0[r32]', label: 'dsp1::i_ecss_max_d_0[r32]' },
            { value: 'dsp1::i_ecss_max_d_1[r32]', label: 'dsp1::i_ecss_max_d_1[r32]' },
            { value: 'dsp1::i_ret[r32]', label: 'dsp1::i_ret[r32]' },
            { value: 'dsp1::p_ecss_max_c_0[r32]', label: 'dsp1::p_ecss_max_c_0[r32]' },
            { value: 'dsp1::p_ecss_max_c_1[r32]', label: 'dsp1::p_ecss_max_c_1[r32]' },
            { value: 'dsp1::p_ecss_max_d_0[r32]', label: 'dsp1::p_ecss_max_d_0[r32]' },
            { value: 'dsp1::p_ecss_max_d_1[r32]', label: 'dsp1::p_ecss_max_d_1[r32]' },
            { value: 'dsp1::p_total_cpu_0[r32]', label: 'dsp1::p_total_cpu_0[r32]' },
            { value: 'dsp1::p_total_cpu_1[r32]', label: 'dsp1::p_total_cpu_1[r32]' },
            { value: 'dsp1::sp_p_0[r32]', label: 'dsp1::sp_p_0[r32]' },
            { value: 'dsp1::sp_p_1[r32]', label: 'dsp1::sp_p_1[r32]' },
            { value: 'dsp1::sp_v_0[r32]', label: 'dsp1::sp_v_0[r32]' },
        ],
    },
    {
        value: 'Group_6',
        label: 'Group 6',
        variables: [
            { value: 'dsp1::sp_v_1[r32]', label: 'dsp1::sp_v_1[r32]' },
            { value: 'dsp1::system_dcdc_state_0[u32]', label: 'dsp1::system_dcdc_state_0[u32]' },
            { value: 'dsp1::system_dcdc_state_1[u32]', label: 'dsp1::system_dcdc_state_1[u32]' },
            { value: 'dsp1::v_bus[r32]', label: 'dsp1::v_bus[r32]' },
            { value: 'dsp1::v_cat[r32]', label: 'dsp1::v_cat[r32]' },
            { value: 'dsp1::v_ess1_esm1[r32]', label: 'dsp1::v_ess1_esm1[r32]' },
            { value: 'dsp1::v_ess2_esm1[r32]', label: 'dsp1::v_ess2_esm1[r32]' },
            { value: 'dsp1::vbus_filt_high[r32]', label: 'dsp1::vbus_filt_high[r32]' },
            { value: 'dsp1::vbus_filt_low[r32]', label: 'dsp1::vbus_filt_low[r32]' },
            { value: 'dsp1::vbus_filt_mid[r32]', label: 'dsp1::vbus_filt_mid[r32]' },
            { value: 'dsp1::vess_1_filt_low[r32]', label: 'dsp1::vess_1_filt_low[r32]' },
            { value: 'dsp1::vess_2_filt_low[r32]', label: 'dsp1::vess_2_filt_low[r32]' },
            { value: 'dsp1::v_pant[r32]', label: 'dsp1::v_pant[r32]' },
        ],
    },
]

export default alarmsChartVariablesData



// WEBPACK FOOTER //
// ./src/data/alarmsChartVariablesData.js